<template>
  <!-- Date input -->
  <div class="field-date" v-if="isVisible">
    <div class="input-group col-12 mx-0 px-0">

      <input :id="'form-day-' + field.form_key" class="form-control col-4 col-md-3"
             type="number" min="01" max="31"
             @keyup="autoTab"
             @change="answerDate('day', field.form_key)"
             :tabIndex="question.id + '_1'"
             v-model="day" placeholder="day"
             autocomplete="bday-day"
             :ref="'field_' + field.form_key"
             :name="'field_day_' + field.form_key"
             @focus="$emit('questionSelected', question.order)"
      >
      <input :id="'form-month-' + field.form_key" class="form-control col-4 col-md-3"
             type="number" min="01" max="12"
             @keyup="autoTab"
             @change="answerDate('month', field.form_key)"
             :tabIndex="question.id + '_2'"
             v-model="month" placeholder="month"
             autocomplete="bday-month"
             :ref="'field_' + field.form_key"
             :name="'field_month_' + field.form_key"
             @focus="$emit('questionSelected', question.order)"
      >
      <input :id="'form-year-' + field.form_key" class="form-control col-4 col-md-3"
             type="number" min="1900" max="9999" maxlength="4"
             @change="answerDate('year', field.form_key)"
             :tabIndex="question.id + '_3'"
             v-model="year" placeholder="year"
             autocomplete="bday-year"
             :ref="'field_' + field.form_key"
             :name="'field_year_' + field.form_key"
             @focus="$emit('questionSelected', question.order)"
      >
    </div>
  </div>
</template>

<script>

import elementMixins from '../mixins/elements'

export default {

	name: 'LUDate',
	mixins: [elementMixins],
	props: [
		'default'
	],

	data: function () {
		return {
			day: null,
			month: null,
			year: null,
			fullDate: null
		}
	},

	watch: {
		fullDate: function () {
			this.answer = this.fullDate
		},
		day: function () {
      // format day to 2 places with preceding zero
			var s = '000000000' + this.day
      // this.day = s.substr(s.length - 2)
		},
		month: function () {
      // format day to 2 places with preceding zero
			var s = '000000000' + this.month
      // this.month = s.substr(s.length - 2)
		}
	},

	methods: {

		autoTab: function (event) {
			if (event.target.value.length >= 2) {
				event.target.nextElementSibling.focus()
			}
		},

		answerDate: function () {
			if (this.day === null || this.month === null || this.year === null) {
				return
			}

			const regex = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/
			if (!regex.test(this.getFormattedDate())) {
				return
			}

			const d = new Date(this.getFormattedDate())
			if (!d) {
				return false
			}

			this.fullDate = this.getFormattedDate()
		},

		getFormattedDate: function () {
			return [this.day, this.month, this.year].join('/')
		},

		calculateAge: function () {
			const birthday = new Date([this.year, this.month, this.day].join('/'))
			const ageDifMs = Date.now() - birthday.getTime()
			const ageDate = new Date(ageDifMs) // miliseconds from epoch
			return Math.abs(ageDate.getUTCFullYear() - 1970)
		}
	},

	mounted: function () {
    // split the defauly value into y/m/d
		if (this.default.length === 10) {
			const parts = this.default.split('/')
			this.day = parts[0]
			this.month = parts[1]
			this.year = parts[2]
		}
	}
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Date.vue